(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.a5.at === region.bn.at)
	{
		return 'on line ' + region.a5.at;
	}
	return 'on lines ' + region.a5.at + ' through ' + region.bn.at;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cC,
		impl.dd,
		impl.c8,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (
		(typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		||
		(Array.isArray(_Json_unwrap(value)) && _VirtualDom_RE_js_html.test(String(_Json_unwrap(value))))
	)
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		Q: func(record.Q),
		a6: record.a6,
		a1: record.a1
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.Q;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.a6;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.a1) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cC,
		impl.dd,
		impl.c8,
		function(sendToApp, initialModel) {
			var view = impl.de;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cC,
		impl.dd,
		impl.c8,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.a4 && impl.a4(sendToApp)
			var view = impl.de;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.W);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.db) && (_VirtualDom_doc.title = title = doc.db);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.cT;
	var onUrlRequest = impl.cU;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		a4: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.bO === next.bO
							&& curr.bv === next.bv
							&& curr.bL.a === next.bL.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		cC: function(flags)
		{
			return A3(impl.cC, flags, _Browser_getUrl(), key);
		},
		de: impl.de,
		dd: impl.dd,
		c8: impl.c8
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { cz: 'hidden', ck: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { cz: 'mozHidden', ck: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { cz: 'msHidden', ck: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { cz: 'webkitHidden', ck: 'webkitvisibilitychange' }
		: { cz: 'hidden', ck: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		bU: _Browser_getScene(),
		b7: {
			ca: _Browser_window.pageXOffset,
			cb: _Browser_window.pageYOffset,
			b9: _Browser_doc.documentElement.clientWidth,
			bu: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		b9: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bu: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			bU: {
				b9: node.scrollWidth,
				bu: node.scrollHeight
			},
			b7: {
				ca: node.scrollLeft,
				cb: node.scrollTop,
				b9: node.clientWidth,
				bu: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			bU: _Browser_getScene(),
			b7: {
				ca: x,
				cb: y,
				b9: _Browser_doc.documentElement.clientWidth,
				bu: _Browser_doc.documentElement.clientHeight
			},
			cr: {
				ca: x + rect.left,
				cb: y + rect.top,
				b9: rect.width,
				bu: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.M.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.M.b, xhr)); });
		$elm$core$Maybe$isJust(request.ad) && _Http_track(router, xhr, request.ad.a);

		try {
			xhr.open(request._, request.T, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.T));
		}

		_Http_configureRequest(xhr, request);

		request.W.a && xhr.setRequestHeader('Content-Type', request.W.a);
		xhr.send(request.W.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.Y; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.ac.a || 0;
	xhr.responseType = request.M.d;
	xhr.withCredentials = request.ce;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		T: xhr.responseURL,
		c6: xhr.status,
		c7: xhr.statusText,
		Y: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			c5: event.loaded,
			bX: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			cZ: event.loaded,
			bX: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var $author$project$State$LinkClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$State$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.i) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.k);
		} else {
			var treeLen = builder.i * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.m) : builder.m;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.i);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.k);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{m: nodeList, i: (len / $elm$core$Array$branchFactor) | 0, k: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bp: fragment, bv: host, bI: path, bL: port_, bO: protocol, cY: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$State$CreatingGame = function (a) {
	return {$: 1, a: a};
};
var $author$project$State$Initial = function (a) {
	return {$: 0, a: a};
};
var $author$project$State$LoadingGameToJoin = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$devApiUrl = 'http://localhost:5001/themashagame-990a8/us-central1';
var $author$project$State$GameFound = F3(
	function (a, b, c) {
		return {$: 39, a: a, b: b, c: c};
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.c6));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $author$project$Game$Game$Game = F8(
	function (id, gameId, ownerId, status, participants, state, turnDurationMs, schemaVersion) {
		return {bq: gameId, bw: id, cX: ownerId, aI: participants, a2: schemaVersion, bZ: state, b_: status, ba: turnDurationMs};
	});
var $author$project$Game$Game$GameState = F9(
	function (words, teams, round, turnTimer, phase, revision, targetRound, deadlineMs, turnId) {
		return {bk: deadlineMs, bJ: phase, bS: revision, c4: round, b3: targetRound, a8: teams, b5: turnId, b6: turnTimer, aA: words};
	});
var $author$project$Game$Words$Words = F3(
	function (guessed, current, next) {
		return {aC: current, cy: guessed, cL: next};
	});
var $author$project$Game$Game$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Game$Teams$Teams = F2(
	function (current, next) {
		return {aC: current, cL: next};
	});
var $author$project$Game$Teams$emptyTeams = A2($author$project$Game$Teams$Teams, $elm$core$Maybe$Nothing, _List_Nil);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Game$Game$AddingWords = 1;
var $author$project$Game$Game$BetweenRounds = 2;
var $author$project$Game$Game$GameFinished = 4;
var $author$project$Game$Game$Lobby = 0;
var $author$project$Game$Game$PlayingRound = 3;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Game$Game$gamePhaseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (phase) {
		switch (phase) {
			case 'lobby':
				return $elm$json$Json$Decode$succeed(0);
			case 'addingWords':
				return $elm$json$Json$Decode$succeed(1);
			case 'betweenRounds':
				return $elm$json$Json$Decode$succeed(2);
			case 'playing':
				return $elm$json$Json$Decode$succeed(3);
			case 'finished':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('game phase unknown');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Game$Helpers$optionalField = F3(
	function (name, decoder, fallback) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (fields) {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(name)),
					fields) ? A2($elm$json$Json$Decode$field, name, decoder) : $elm$json$Json$Decode$succeed(fallback);
			},
			$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Game$Helpers$optionalMaybeField = F2(
	function (name, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					name,
					$elm$json$Json$Decode$nullable(decoder)),
					$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
				]));
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Game$Teams$Team = F2(
	function (playerIds, score) {
		return {a0: playerIds, a3: score};
	});
var $author$project$Game$Teams$teamDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Game$Teams$Team,
	A2(
		$elm$json$Json$Decode$field,
		'playerIds',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'score', $elm$json$Json$Decode$int));
var $author$project$Game$Teams$teamsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Game$Teams$Teams,
	A2($author$project$Game$Helpers$optionalMaybeField, 'current', $author$project$Game$Teams$teamDecoder),
	A3(
		$author$project$Game$Helpers$optionalField,
		'next',
		$elm$json$Json$Decode$list($author$project$Game$Teams$teamDecoder),
		_List_Nil));
var $author$project$Game$Game$NotTicking = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$Game$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Game$Game$Ticking = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$Game$turnTimerDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (timerType) {
		switch (timerType) {
			case 'running':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Game$Game$Ticking,
					A2($elm$json$Json$Decode$field, 'deadlineMs', $elm$json$Json$Decode$float));
			case 'paused':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Game$Game$NotTicking,
					A2($elm$json$Json$Decode$field, 'remainingMs', $elm$json$Json$Decode$int));
			case 'reset':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Game$Game$Restarted,
					A2($elm$json$Json$Decode$field, 'remainingMs', $elm$json$Json$Decode$int));
			default:
				return $elm$json$Json$Decode$fail('turn timer status unknown');
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Game$Words$Word = F3(
	function (word, playerId, id) {
		return {bw: id, aJ: playerId, bc: word};
	});
var $author$project$Game$Words$wordDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Game$Words$Word,
	A2($elm$json$Json$Decode$field, 'word', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'playerId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
var $author$project$Game$Words$wordsDecoder = function () {
	var dictToValueList = A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$toList,
			$elm$core$List$map($elm$core$Tuple$second)),
		$elm$json$Json$Decode$dict($author$project$Game$Words$wordDecoder));
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Game$Words$Words,
		A3($author$project$Game$Helpers$optionalField, 'guessed', dictToValueList, _List_Nil),
		A2($author$project$Game$Helpers$optionalMaybeField, 'current', $author$project$Game$Words$wordDecoder),
		A3($author$project$Game$Helpers$optionalField, 'next', dictToValueList, _List_Nil));
}();
var $author$project$Game$Game$gameStateDecoder = A2(
	$author$project$Game$Game$andMap,
	A2($elm$json$Json$Decode$field, 'turnId', $elm$json$Json$Decode$int),
	A2(
		$author$project$Game$Game$andMap,
		A2($author$project$Game$Helpers$optionalMaybeField, 'deadlineMs', $elm$json$Json$Decode$float),
		A2(
			$author$project$Game$Game$andMap,
			A2($author$project$Game$Helpers$optionalMaybeField, 'targetRound', $elm$json$Json$Decode$int),
			A2(
				$author$project$Game$Game$andMap,
				A2($elm$json$Json$Decode$field, 'revision', $elm$json$Json$Decode$int),
				A2(
					$author$project$Game$Game$andMap,
					A2($elm$json$Json$Decode$field, 'phase', $author$project$Game$Game$gamePhaseDecoder),
					A2(
						$author$project$Game$Game$andMap,
						A2($elm$json$Json$Decode$field, 'turnTimer', $author$project$Game$Game$turnTimerDecoder),
						A2(
							$author$project$Game$Game$andMap,
							A2($elm$json$Json$Decode$field, 'round', $elm$json$Json$Decode$int),
							A2(
								$author$project$Game$Game$andMap,
								A3($author$project$Game$Helpers$optionalField, 'teams', $author$project$Game$Teams$teamsDecoder, $author$project$Game$Teams$emptyTeams),
								A2(
									$author$project$Game$Game$andMap,
									A3(
										$author$project$Game$Helpers$optionalField,
										'words',
										$author$project$Game$Words$wordsDecoder,
										A3($author$project$Game$Words$Words, _List_Nil, $elm$core$Maybe$Nothing, _List_Nil)),
									$elm$json$Json$Decode$succeed($author$project$Game$Game$GameState))))))))));
var $author$project$Game$Status$Finished = 2;
var $author$project$Game$Status$Open = 0;
var $author$project$Game$Status$Running = 1;
var $author$project$Game$Status$gameStatusStringDecoder = function (stringStatus) {
	switch (stringStatus) {
		case 'open':
			return $elm$json$Json$Decode$succeed(0);
		case 'running':
			return $elm$json$Json$Decode$succeed(1);
		case 'finished':
			return $elm$json$Json$Decode$succeed(2);
		default:
			return $elm$json$Json$Decode$fail('game status unknown');
	}
};
var $author$project$Game$Status$gameStatusDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Game$Status$gameStatusStringDecoder, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Game$Participants$Participants = function (players) {
	return {aK: players};
};
var $author$project$Player$Offline = 1;
var $author$project$Player$Player = F4(
	function (id, name, role, status) {
		return {bw: id, bC: name, c3: role, b_: status};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Player$PlayerRole = 0;
var $author$project$Player$WatcherRole = 1;
var $author$project$Player$roleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (role) {
		switch (role) {
			case 'player':
				return $elm$json$Json$Decode$succeed(0);
			case 'watcher':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('player role unknown');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Player$playerDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Player$Player,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'role', $author$project$Player$roleDecoder),
	$elm$json$Json$Decode$succeed(1));
var $author$project$Game$Participants$participantsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Game$Participants$Participants,
	A2(
		$elm$json$Json$Decode$field,
		'players',
		$elm$json$Json$Decode$dict($author$project$Player$playerDecoder)));
var $author$project$Game$Game$schemaVersionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (version) {
		return (version === 1) ? $elm$json$Json$Decode$succeed(version) : $elm$json$Json$Decode$fail('unsupported game schema');
	},
	$elm$json$Json$Decode$int);
var $author$project$Game$Game$gameDecoder = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Game$Game$Game,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'gameId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ownerId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'status', $author$project$Game$Status$gameStatusDecoder),
	A2($elm$json$Json$Decode$field, 'participants', $author$project$Game$Participants$participantsDecoder),
	A2($elm$json$Json$Decode$field, 'state', $author$project$Game$Game$gameStateDecoder),
	A2($elm$json$Json$Decode$field, 'turnDurationMs', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'schemaVersion', $author$project$Game$Game$schemaVersionDecoder));
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {bQ: reqs, b1: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.ad;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.bQ));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.b1)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					ce: r.ce,
					W: r.W,
					M: A2(_Http_mapExpect, func, r.M),
					Y: r.Y,
					_: r._,
					ac: r.ac,
					ad: r.ad,
					T: r.T
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{ce: false, W: r.W, M: r.M, Y: r.Y, _: r._, ac: r.ac, ad: r.ad, T: r.T}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{W: $elm$http$Http$emptyBody, M: r.M, Y: _List_Nil, _: 'GET', ac: $elm$core$Maybe$Nothing, ad: $elm$core$Maybe$Nothing, T: r.T});
};
var $author$project$Api$protocolVersion = 1;
var $author$project$Api$findGame = F3(
	function (apiUrl, requestId, gameCode) {
		return $elm$http$Http$get(
			{
				M: A2(
					$elm$http$Http$expectJson,
					A2($author$project$State$GameFound, requestId, gameCode),
					$author$project$Game$Game$gameDecoder),
				T: apiUrl + ('/findGame?gameId=' + (gameCode + ('&protocolVersion=' + $elm$core$String$fromInt($author$project$Api$protocolVersion))))
			});
	});
var $author$project$Request$Idle = {$: 0};
var $author$project$Request$idle = $author$project$Request$Idle;
var $author$project$Request$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Request$loading = function (requestId) {
	return $author$project$Request$Loading(requestId);
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Route$None = {$: 2};
var $author$project$Route$Create = {$: 1};
var $author$project$Route$Join = function (a) {
	return {$: 0, a: a};
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {X: frag, aa: params, S: unvisited, K: value, af: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.af;
		var unvisited = _v0.S;
		var params = _v0.aa;
		var frag = _v0.X;
		var value = _v0.K;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.af;
			var unvisited = _v1.S;
			var params = _v1.aa;
			var frag = _v1.X;
			var value = _v1.K;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.af;
		var unvisited = _v0.S;
		var params = _v0.aa;
		var frag = _v0.X;
		var value = _v0.K;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.af;
			var unvisited = _v0.S;
			var params = _v0.aa;
			var frag = _v0.X;
			var value = _v0.K;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Route$matchRoute = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Join,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('join'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Create,
			$elm$url$Url$Parser$s('create'))
		]));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.S;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.K);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.K);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.bI),
					$elm$url$Url$Parser$prepareQuery(url.cY),
					url.bp,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$parseUrl = function (url) {
	var _v0 = A2($elm$url$Url$Parser$parse, $author$project$Route$matchRoute, url);
	if (!_v0.$) {
		var route = _v0.a;
		return route;
	} else {
		return $author$project$Route$None;
	}
};
var $author$project$Main$init = F3(
	function (flags, url, navKey) {
		var route = $author$project$Route$parseUrl(url);
		var apiUrl = (flags.cs === 'development') ? $author$project$Main$devApiUrl : '';
		return _Utils_Tuple2(
			{
				g: apiUrl,
				l: flags.l,
				ag: flags.ag,
				cm: function () {
					switch (route.$) {
						case 0:
							var gameCode = route.a;
							return $author$project$State$LoadingGameToJoin(
								{
									N: gameCode,
									d: $author$project$Request$loading(
										_Utils_Tuple2(0, gameCode))
								});
						case 1:
							return $author$project$State$CreatingGame(
								{aB: flags.ag + '-0', A: '', d: $author$project$Request$idle});
						default:
							return $author$project$State$Initial(
								{E: 1, B: ''});
					}
				}(),
				cs: flags.cs,
				aD: _List_Nil,
				aW: false,
				aX: false,
				ak: navKey,
				b: function () {
					switch (route.$) {
						case 0:
							return 1;
						case 1:
							return 1;
						default:
							return 0;
					}
				}(),
				aG: $elm$time$Time$millisToPosix(0),
				D: route,
				aO: 0,
				T: url
			},
			function () {
				if (!route.$) {
					var gameCode = route.a;
					return A3($author$project$Api$findGame, apiUrl, 0, gameCode);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$State$AuthTokenChanged = function (a) {
	return {$: 44, a: a};
};
var $author$project$State$GameChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$State$PresenceChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$State$ReceivedUsernameFromLocalStorage = function (a) {
	return {$: 45, a: a};
};
var $author$project$State$ServerTimeOffsetChanged = function (a) {
	return {$: 25, a: a};
};
var $author$project$State$TimerTick = function (a) {
	return {$: 24, a: a};
};
var $author$project$State$TransitionTick = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$authTokenChanged = _Platform_incomingPort('authTokenChanged', $elm$json$Json$Decode$string);
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {bN: processes, b2: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.bN;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.b2);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Main$gameChanged = _Platform_incomingPort('gameChanged', $elm$json$Json$Decode$value);
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Game$Gameplay$isRoundEnd = function (gameState) {
	var _v0 = gameState.aA.aC;
	if (!_v0.$) {
		return false;
	} else {
		return $elm$core$List$isEmpty(gameState.aA.cL);
	}
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Main$presenceChanged = _Platform_incomingPort(
	'presenceChanged',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Main$receivedUsernameFromLocalStorage = _Platform_incomingPort('receivedUsernameFromLocalStorage', $elm$json$Json$Decode$string);
var $author$project$Main$serverTimeOffsetChanged = _Platform_incomingPort('serverTimeOffsetChanged', $elm$json$Json$Decode$float);
var $author$project$Main$subscriptions = function (model) {
	var transitionSub = function () {
		var _v2 = model.cm;
		if (_v2.$ === 4) {
			var gameModel = _v2.a;
			var _v3 = gameModel.cH;
			if (_v3.$ === 1) {
				return $elm$core$Platform$Sub$none;
			} else {
				return (((gameModel.x.bZ.bJ === 3) && $author$project$Game$Gameplay$isRoundEnd(gameModel.x.bZ)) || (gameModel.x.bZ.bJ === 2)) ? A2($elm$time$Time$every, 1000, $author$project$State$TransitionTick) : $elm$core$Platform$Sub$none;
			}
		} else {
			return $elm$core$Platform$Sub$none;
		}
	}();
	var timerSub = function () {
		var _v0 = model.cm;
		switch (_v0.$) {
			case 4:
				var gameModel = _v0.a;
				var _v1 = gameModel.x.bZ.b6;
				if (!_v1.$) {
					return A2($elm$time$Time$every, 1000, $author$project$State$TimerTick);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			case 0:
				return A2($elm$time$Time$every, 5000, $author$project$State$TimerTick);
			default:
				return $elm$core$Platform$Sub$none;
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Main$gameChanged($author$project$State$GameChanged),
				$author$project$Main$authTokenChanged($author$project$State$AuthTokenChanged),
				$author$project$Main$serverTimeOffsetChanged($author$project$State$ServerTimeOffsetChanged),
				$author$project$Main$receivedUsernameFromLocalStorage($author$project$State$ReceivedUsernameFromLocalStorage),
				$author$project$Main$presenceChanged($author$project$State$PresenceChanged),
				timerSub,
				transitionSub
			]));
};
var $author$project$State$JoiningGame = function (a) {
	return {$: 3, a: a};
};
var $author$project$State$LocalPlayer = function (a) {
	return {$: 0, a: a};
};
var $author$project$State$LocalWatcher = function (a) {
	return {$: 1, a: a};
};
var $author$project$State$Playing = function (a) {
	return {$: 4, a: a};
};
var $author$project$State$GameAdded = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Api$addedGameResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'game', $author$project$Game$Game$gameDecoder),
	A2($elm$json$Json$Decode$field, 'player', $author$project$Player$playerDecoder));
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$commandBody = function (fields) {
	return $elm$http$Http$jsonBody(
		$elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'protocolVersion',
					$elm$json$Json$Encode$int($author$project$Api$protocolVersion)),
				fields)));
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Api$addGame = F5(
	function (apiUrl, authToken, requestId, clientRequestId, username) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'displayName',
							$elm$json$Json$Encode$string(username)),
							_Utils_Tuple2(
							'clientRequestId',
							$elm$json$Json$Encode$string(clientRequestId))
						])),
				M: A2(
					$elm$http$Http$expectJson,
					$author$project$State$GameAdded(requestId),
					$author$project$Api$addedGameResponseDecoder),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + '/addGame'
			});
	});
var $author$project$Request$begin = F2(
	function (requestId, state) {
		if (state.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				$author$project$Request$Loading(requestId));
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Request$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Request$isActive = F2(
	function (requestId, state) {
		if (state.$ === 1) {
			var activeRequestId = state.a;
			return _Utils_eq(activeRequestId, requestId);
		} else {
			return false;
		}
	});
var $author$project$Request$fail = F3(
	function (requestId, requestError, state) {
		return A2($author$project$Request$isActive, requestId, state) ? $author$project$Request$Failed(requestError) : state;
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Main$getUsernameFromLocalStorage = _Platform_outgoingPort(
	'getUsernameFromLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Main$invalidatePendingNavigation = function (currentGame) {
	switch (currentGame.$) {
		case 1:
			return $author$project$State$Initial(
				{E: 1, B: ''});
		case 2:
			return $author$project$State$Initial(
				{E: 1, B: ''});
		case 3:
			return $author$project$State$Initial(
				{E: 1, B: ''});
		default:
			return currentGame;
	}
};
var $author$project$State$JoinedGame = F3(
	function (a, b, c) {
		return {$: 41, a: a, b: b, c: c};
	});
var $author$project$State$JoinedGameInfo = F4(
	function (status, role, player, game) {
		return {x: game, a$: player, c3: role, b_: status};
	});
var $author$project$Api$joinedGameResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$State$JoinedGameInfo,
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'role', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'player', $author$project$Player$playerDecoder),
	A2($elm$json$Json$Decode$field, 'game', $author$project$Game$Game$gameDecoder));
var $author$project$Api$joinGame = F5(
	function (apiUrl, authToken, requestId, gameId, username) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gameId',
							$elm$json$Json$Encode$string(gameId)),
							_Utils_Tuple2(
							'displayName',
							$elm$json$Json$Encode$string(username))
						])),
				M: A2(
					$elm$http$Http$expectJson,
					A2($author$project$State$JoinedGame, requestId, gameId),
					$author$project$Api$joinedGameResponseDecoder),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + '/joinGame'
			});
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Main$localPlayerId = function (localUser) {
	if (!localUser.$) {
		var player = localUser.a;
		return player.bw;
	} else {
		var player = localUser.a;
		return player.bw;
	}
};
var $author$project$Player$Online = 0;
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Game$Gameplay$withPresence = F3(
	function (localPlayerId, onlineIds, game) {
		var participants = game.aI;
		var players = A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, player) {
					return _Utils_update(
						player,
						{
							b_: (_Utils_eq(player.bw, localPlayerId) || A2($elm$core$Set$member, player.bw, onlineIds)) ? 0 : 1
						});
				}),
			participants.aK);
		return _Utils_update(
			game,
			{
				aI: _Utils_update(
					participants,
					{aK: players})
			});
	});
var $author$project$Main$presentGame = F2(
	function (gameModel, game) {
		return A3(
			$author$project$Game$Gameplay$withPresence,
			$author$project$Main$localPlayerId(gameModel.cH),
			gameModel.aH,
			game);
	});
var $author$project$Main$newPlaying = F2(
	function (game, localUser) {
		var gameModel = {U: $author$project$Request$idle, x: game, cD: false, aj: false, O: false, cH: localUser, aH: $elm$core$Set$empty, av: $elm$core$Maybe$Nothing, aR: ''};
		return _Utils_update(
			gameModel,
			{
				x: A2($author$project$Main$presentGame, gameModel, game)
			});
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$State$WordInputFocused = function (a) {
	return {$: 43, a: a};
};
var $author$project$State$WordAdded = F3(
	function (a, b, c) {
		return {$: 42, a: a, b: b, c: c};
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Api$addWord = F6(
	function (apiUrl, authToken, requestId, gameId, wordId, text) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gameId',
							$elm$json$Json$Encode$string(gameId)),
							_Utils_Tuple2(
							'wordId',
							$elm$json$Json$Encode$string(wordId)),
							_Utils_Tuple2(
							'text',
							$elm$json$Json$Encode$string(text))
						])),
				M: $elm$http$Http$expectString(
					A2($author$project$State$WordAdded, requestId, gameId)),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + '/addWord'
			});
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Main$copyInviteLink = _Platform_outgoingPort('copyInviteLink', $elm$core$Basics$identity);
var $author$project$State$NoOpResult = function (a) {
	return {$: 46, a: a};
};
var $author$project$Api$deleteWord = F4(
	function (apiUrl, authToken, gameId, wordId) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gameId',
							$elm$json$Json$Encode$string(gameId)),
							_Utils_Tuple2(
							'wordId',
							$elm$json$Json$Encode$string(wordId))
						])),
				M: $elm$http$Http$expectString($author$project$State$NoOpResult),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + '/deleteWord'
			});
	});
var $author$project$Api$roundTransitionRequest = F6(
	function (apiUrl, authToken, gameId, endpoint, expectedRevision, toMsg) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gameId',
							$elm$json$Json$Encode$string(gameId)),
							_Utils_Tuple2(
							'expectedRevision',
							$elm$json$Json$Encode$int(expectedRevision))
						])),
				M: $elm$http$Http$expectString(toMsg),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + ('/' + endpoint)
			});
	});
var $author$project$Api$advanceRound = F4(
	function (apiUrl, authToken, gameId, expectedRevision) {
		return A6($author$project$Api$roundTransitionRequest, apiUrl, authToken, gameId, 'advanceRound', expectedRevision, $author$project$State$NoOpResult);
	});
var $author$project$Game$Interstitial$AdvanceRound = 1;
var $author$project$Game$Interstitial$EnterBetweenRounds = 0;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Game$Interstitial$dueTransition = F3(
	function (serverTimeOffsetMs, now, game) {
		var serverNow = $elm$time$Time$posixToMillis(now) + serverTimeOffsetMs;
		var _v0 = game.bZ.bJ;
		switch (_v0) {
			case 3:
				return $author$project$Game$Gameplay$isRoundEnd(game.bZ) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
			case 2:
				var _v1 = game.bZ.bk;
				if (!_v1.$) {
					var deadlineMs = _v1.a;
					return (_Utils_cmp(serverNow, deadlineMs) > -1) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Api$enterBetweenRounds = F4(
	function (apiUrl, authToken, gameId, expectedRevision) {
		return A6($author$project$Api$roundTransitionRequest, apiUrl, authToken, gameId, 'enterBetweenRounds', expectedRevision, $author$project$State$NoOpResult);
	});
var $author$project$Main$dueTransitionCmd = F2(
	function (model, game) {
		var _v0 = A3($author$project$Game$Interstitial$dueTransition, model.aO, model.aG, game);
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return A4($author$project$Api$enterBetweenRounds, model.g, model.l, game.bw, game.bZ.bS);
			} else {
				var _v2 = _v0.a;
				return A4($author$project$Api$advanceRound, model.g, model.l, game.bw, game.bZ.bS);
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$turnCommandRequest = F6(
	function (apiUrl, authToken, gameId, endpoint, expectedRevision, expectedTurnId) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gameId',
							$elm$json$Json$Encode$string(gameId)),
							_Utils_Tuple2(
							'expectedRevision',
							$elm$json$Json$Encode$int(expectedRevision)),
							_Utils_Tuple2(
							'expectedTurnId',
							$elm$json$Json$Encode$int(expectedTurnId))
						])),
				M: $elm$http$Http$expectString($author$project$State$NoOpResult),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + ('/' + endpoint)
			});
	});
var $author$project$Api$expireTurn = F5(
	function (apiUrl, authToken, gameId, expectedRevision, expectedTurnId) {
		return A6($author$project$Api$turnCommandRequest, apiUrl, authToken, gameId, 'expireTurn', expectedRevision, expectedTurnId);
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Main$gameChangedUpdate = F3(
	function (value, model, gameModel) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Game$Game$gameDecoder, value);
		if (!_v0.$) {
			var decodedGame = _v0.a;
			if (!_Utils_eq(gameModel.x.bw, decodedGame.bw)) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				var timerRefreshCmd = function () {
					var _v2 = decodedGame.bZ.b6;
					if (!_v2.$) {
						return A2($elm$core$Task$perform, $author$project$State$TimerTick, $elm$time$Time$now);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var remainsInWordEntry = decodedGame.bZ.bJ === 1;
				var nextGameModel = _Utils_update(
					gameModel,
					{
						x: A2($author$project$Main$presentGame, gameModel, decodedGame),
						cD: false,
						aj: gameModel.aj && remainsInWordEntry,
						O: gameModel.O && remainsInWordEntry
					});
				var transitionCmd = function () {
					var _v1 = gameModel.cH;
					if (_v1.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						return A2($author$project$Main$dueTransitionCmd, model, nextGameModel.x);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cm: $author$project$State$Playing(nextGameModel)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[timerRefreshCmd, transitionCmd])));
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$guessWord = F5(
	function (apiUrl, authToken, gameId, expectedRevision, expectedTurnId) {
		return A6($author$project$Api$turnCommandRequest, apiUrl, authToken, gameId, 'guessWord', expectedRevision, expectedTurnId);
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Game$Gameplay$isExplaining = F2(
	function (game, player) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(player.bw),
				A2(
					$elm$core$Maybe$andThen,
					function (team) {
						return $elm$core$List$head(team.a0);
					},
					game.bZ.a8.aC)));
	});
var $author$project$Game$Gameplay$isOwner = F2(
	function (game, player) {
		return _Utils_eq(game.cX, player.bw);
	});
var $author$project$Api$kickPlayer = F4(
	function (apiUrl, authToken, userId, gameId) {
		return $elm$http$Http$request(
			{
				W: $author$project$Api$commandBody(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'userId',
							$elm$json$Json$Encode$string(userId)),
							_Utils_Tuple2(
							'gameId',
							$elm$json$Json$Encode$string(gameId))
						])),
				M: $elm$http$Http$expectString($author$project$State$NoOpResult),
				Y: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + authToken)
					]),
				_: 'POST',
				ac: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				T: apiUrl + '/kickPlayer'
			});
	});
var $author$project$Api$pauseTurn = F5(
	function (apiUrl, authToken, gameId, expectedRevision, expectedTurnId) {
		return A6($author$project$Api$turnCommandRequest, apiUrl, authToken, gameId, 'pauseTurn', expectedRevision, expectedTurnId);
	});
var $author$project$State$StartBetweenRoundsCompleted = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$startBetweenRounds = F4(
	function (apiUrl, authToken, gameId, expectedRevision) {
		return A6($author$project$Api$roundTransitionRequest, apiUrl, authToken, gameId, 'enterBetweenRounds', expectedRevision, $author$project$State$StartBetweenRoundsCompleted);
	});
var $author$project$Api$startGame = F4(
	function (apiUrl, authToken, gameId, expectedRevision) {
		return A6($author$project$Api$roundTransitionRequest, apiUrl, authToken, gameId, 'startGame', expectedRevision, $author$project$State$NoOpResult);
	});
var $author$project$Api$startTurn = F5(
	function (apiUrl, authToken, gameId, expectedRevision, expectedTurnId) {
		return A6($author$project$Api$turnCommandRequest, apiUrl, authToken, gameId, 'startTurn', expectedRevision, expectedTurnId);
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$core$String$trim = _String_trim;
var $author$project$Fixtures$Teams$defaultTestTeams = A2(
	$author$project$Game$Teams$Teams,
	$elm$core$Maybe$Just(
		A2(
			$author$project$Game$Teams$Team,
			_List_fromArray(
				['1', '2']),
			0)),
	_List_fromArray(
		[
			A2(
			$author$project$Game$Teams$Team,
			_List_fromArray(
				['2-1', '2-2']),
			0),
			A2(
			$author$project$Game$Teams$Team,
			_List_fromArray(
				['3-1', '3-2']),
			0)
		]));
var $author$project$Fixtures$State$wordsList = _List_fromArray(
	[
		A3($author$project$Game$Words$Word, 'desk', '1', ''),
		A3($author$project$Game$Words$Word, 'keyboard', '1', ''),
		A3($author$project$Game$Words$Word, 'computer', '1', ''),
		A3($author$project$Game$Words$Word, 'orange', '2', ''),
		A3($author$project$Game$Words$Word, 'mango', '2', ''),
		A3($author$project$Game$Words$Word, 'apple', '2', ''),
		A3($author$project$Game$Words$Word, 'glass', '2-1', ''),
		A3($author$project$Game$Words$Word, 'cup', '2-1', ''),
		A3($author$project$Game$Words$Word, 'plate', '2-1', '')
	]);
var $author$project$Fixtures$State$words = A3($author$project$Game$Words$Words, _List_Nil, $elm$core$Maybe$Nothing, $author$project$Fixtures$State$wordsList);
var $author$project$Fixtures$State$defaultTestState = A9(
	$author$project$Game$Game$GameState,
	$author$project$Fixtures$State$words,
	$author$project$Fixtures$Teams$defaultTestTeams,
	1,
	$author$project$Game$Game$Restarted(60000),
	3,
	2,
	$elm$core$Maybe$Nothing,
	$elm$core$Maybe$Nothing,
	1);
var $author$project$Fixtures$Game$emptyGame = function (game) {
	return _Utils_update(
		game,
		{
			cX: '',
			aI: $author$project$Game$Participants$Participants($elm$core$Dict$empty),
			a2: 1,
			bZ: $author$project$Fixtures$State$defaultTestState,
			ba: 60000
		});
};
var $author$project$Debugger$Update$getOwner = function (gameModel) {
	return A2($elm$core$Dict$get, gameModel.x.cX, gameModel.x.aI.aK);
};
var $author$project$Fixtures$Game$getPlayerOnTurn = function (game) {
	return A2(
		$elm$core$Maybe$andThen,
		function (playerId) {
			return A2($elm$core$Dict$get, playerId, game.aI.aK);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (team) {
				return $elm$core$List$head(team.a0);
			},
			game.bZ.a8.aC));
};
var $author$project$Fixtures$Game$guessNextWords = function (game) {
	var oldState = game.bZ;
	var newWords = A3(
		$author$project$Game$Words$Words,
		_Utils_ap(game.bZ.aA.cL, game.bZ.aA.cy),
		game.bZ.aA.aC,
		_List_Nil);
	return _Utils_update(
		game,
		{
			bZ: _Utils_update(
				oldState,
				{aA: newWords})
		});
};
var $author$project$Fixtures$Teams$testPlayers4 = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'1',
			A4($author$project$Player$Player, '1', 'p1', 0, 0)),
			_Utils_Tuple2(
			'2',
			A4($author$project$Player$Player, '2', 'p2', 0, 0)),
			_Utils_Tuple2(
			'2-1',
			A4($author$project$Player$Player, '2-1', 'p21', 0, 0)),
			_Utils_Tuple2(
			'2-2',
			A4($author$project$Player$Player, '2-2', 'p22', 0, 0))
		]));
var $author$project$Fixtures$Game$lobbyGame = function (game) {
	return _Utils_update(
		game,
		{
			cX: '1',
			aI: $author$project$Game$Participants$Participants($author$project$Fixtures$Teams$testPlayers4),
			a2: 1,
			bZ: $author$project$Fixtures$State$defaultTestState,
			b_: 0,
			ba: 60000
		});
};
var $author$project$Fixtures$Teams$testPlayers6 = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'1',
			A4($author$project$Player$Player, '1', 'p1', 0, 0)),
			_Utils_Tuple2(
			'2',
			A4($author$project$Player$Player, '2', 'p2', 0, 0)),
			_Utils_Tuple2(
			'2-1',
			A4($author$project$Player$Player, '2-1', 'p21', 0, 0)),
			_Utils_Tuple2(
			'2-2',
			A4($author$project$Player$Player, '2-2', 'p22', 0, 0)),
			_Utils_Tuple2(
			'3-1',
			A4($author$project$Player$Player, '3-1', 'p31', 0, 0)),
			_Utils_Tuple2(
			'3-2',
			A4($author$project$Player$Player, '3-2', 'p32', 0, 0))
		]));
var $author$project$Fixtures$Game$newlyStartedGame = function (game) {
	return _Utils_update(
		game,
		{
			cX: '1',
			aI: $author$project$Game$Participants$Participants($author$project$Fixtures$Teams$testPlayers6),
			a2: 1,
			bZ: $author$project$Fixtures$State$defaultTestState,
			b_: 1,
			ba: 60000
		});
};
var $author$project$Debugger$Update$removePlayer = F2(
	function (playerId, game) {
		var participants = game.aI;
		return _Utils_update(
			game,
			{
				aI: _Utils_update(
					participants,
					{
						aK: A2($elm$core$Dict$remove, playerId, participants.aK)
					})
			});
	});
var $author$project$Fixtures$Game$restartWordsToFixture = function (game) {
	var oldState = game.bZ;
	var newState = _Utils_update(
		oldState,
		{aA: $author$project$Fixtures$State$words});
	return _Utils_update(
		game,
		{bZ: newState});
};
var $author$project$Fixtures$Game$rotateCurrentTeam = function (game) {
	var oldState = game.bZ;
	var teams = oldState.a8;
	var rotated = function () {
		var _v0 = teams.aC;
		if (!_v0.$) {
			var team = _v0.a;
			var _v1 = team.a0;
			if (_v1.b) {
				var first = _v1.a;
				var rest = _v1.b;
				return _Utils_update(
					teams,
					{
						aC: $elm$core$Maybe$Just(
							_Utils_update(
								team,
								{
									a0: _Utils_ap(
										rest,
										_List_fromArray(
											[first]))
								}))
					});
			} else {
				return teams;
			}
		} else {
			return teams;
		}
	}();
	return _Utils_update(
		game,
		{
			bZ: _Utils_update(
				oldState,
				{a8: rotated})
		});
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Debugger$Update$upadateGame = F2(
	function (gameModel, game) {
		var localUser = function () {
			var _v0 = gameModel.cH;
			if (!_v0.$) {
				var p = _v0.a;
				return p;
			} else {
				var w = _v0.a;
				return w;
			}
		}();
		var newLocalUser = $author$project$State$LocalPlayer(
			A2(
				$elm$core$Maybe$withDefault,
				localUser,
				$elm$core$List$head(
					$elm$core$Dict$values(game.aI.aK))));
		return $author$project$State$Playing(
			_Utils_update(
				gameModel,
				{x: game, cD: true, cH: newLocalUser}));
	});
var $author$project$Debugger$Update$update = F2(
	function (msg, model) {
		var _v0 = model.cm;
		if (_v0.$ === 4) {
			var gameModel = _v0.a;
			switch (msg.$) {
				case 30:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									$author$project$Fixtures$Game$emptyGame(gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				case 31:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									$author$project$Fixtures$Game$lobbyGame(gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				case 32:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									$author$project$Fixtures$Game$newlyStartedGame(gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				case 33:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									$author$project$Fixtures$Game$restartWordsToFixture(gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				case 36:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									$author$project$Fixtures$Game$rotateCurrentTeam(gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				case 34:
					var playerOnTurn = $author$project$Fixtures$Game$getPlayerOnTurn(gameModel.x);
					if (!playerOnTurn.$) {
						var player = playerOnTurn.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											gameModel,
											{
												cH: $author$project$State$LocalPlayer(player)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 35:
					var _v3 = $author$project$Debugger$Update$getOwner(gameModel);
					if (!_v3.$) {
						var player = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											gameModel,
											{
												cH: $author$project$State$LocalPlayer(player)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 37:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									$author$project$Fixtures$Game$guessNextWords(gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				case 38:
					var newRound = msg.a;
					var oldGame = gameModel.x;
					var oldState = oldGame.bZ;
					var newGame = _Utils_update(
						oldGame,
						{
							bZ: _Utils_update(
								oldState,
								{c4: newRound})
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2($author$project$Debugger$Update$upadateGame, gameModel, newGame)
							}),
						$elm$core$Platform$Cmd$none);
				case 11:
					var playerId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2(
									$author$project$Debugger$Update$upadateGame,
									gameModel,
									A2($author$project$Debugger$Update$removePlayer, playerId, gameModel.x))
							}),
						$elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Game$Words$wordToKey = F2(
	function (_v0, index) {
		var word = _v0.bc;
		var playerId = _v0.aJ;
		var formattedIndex = A2(
			$elm$core$String$right,
			3,
			'000' + $elm$core$String$fromInt(index));
		return formattedIndex + ('-' + (word + ('-' + playerId)));
	});
var $author$project$Game$Words$wordWithKey = F2(
	function (index, word) {
		return _Utils_update(
			word,
			{
				bw: A2($author$project$Game$Words$wordToKey, word, index)
			});
	});
var $author$project$Main$playingGameUpdate = F2(
	function (msg, model) {
		var _v0 = model.cm;
		if (_v0.$ === 4) {
			var gameModel = _v0.a;
			var _v1 = gameModel.cH;
			if (!_v1.$) {
				var localPlayer = _v1.a;
				var game = gameModel.x;
				switch (msg.$) {
					case 14:
						var input = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											gameModel,
											{aR: input}))
								}),
							$elm$core$Platform$Cmd$none);
					case 16:
						var submittedWord = $elm$core$String$toUpper(
							$elm$core$String$trim(gameModel.aR));
						if ($elm$core$String$isEmpty(submittedWord)) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							var _v3 = A2(
								$author$project$Request$begin,
								_Utils_Tuple2(model.b, game.bw),
								gameModel.U);
							if (!_v3.$) {
								var request = _v3.a;
								var newWord = A2(
									$author$project$Game$Words$wordWithKey,
									0,
									A3($author$project$Game$Words$Word, submittedWord, localPlayer.bw, ''));
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$Playing(
												_Utils_update(
													gameModel,
													{U: request})),
											b: model.b + 1
										}),
									A6($author$project$Api$addWord, model.g, model.l, model.b, game.bw, newWord.bw, newWord.bc));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						}
					case 42:
						var requestId = msg.a;
						var gameId = msg.b;
						var result = msg.c;
						if (!A2(
							$author$project$Request$isActive,
							_Utils_Tuple2(requestId, gameId),
							gameModel.U)) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							if (!result.$) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$Playing(
												_Utils_update(
													gameModel,
													{U: $author$project$Request$idle, aR: ''}))
										}),
									A2(
										$elm$core$Task$attempt,
										$author$project$State$WordInputFocused,
										$elm$browser$Browser$Dom$focus('word')));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$Playing(
												_Utils_update(
													gameModel,
													{
														U: A3(
															$author$project$Request$fail,
															_Utils_Tuple2(requestId, gameId),
															'Could not add the word. Try again.',
															gameModel.U)
													}))
										}),
									$elm$core$Platform$Cmd$none);
							}
						}
					case 22:
						var id = msg.a;
						return _Utils_Tuple2(
							model,
							A4($author$project$Api$deleteWord, model.g, model.l, game.bw, id));
					case 23:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Initial(
										{E: 1, B: ''}),
									aD: _List_Nil
								}),
							$elm$core$Platform$Cmd$none);
					case 24:
						var now = msg.a;
						var expiryCmd = function () {
							var _v5 = game.bZ.b6;
							if (!_v5.$) {
								var deadlineMs = _v5.a;
								return (_Utils_cmp(
									$elm$time$Time$posixToMillis(now) + model.aO,
									deadlineMs) > -1) ? A5($author$project$Api$expireTurn, model.g, model.l, game.bw, game.bZ.bS, game.bZ.b5) : $elm$core$Platform$Cmd$none;
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aG: now}),
							expiryCmd);
					case 26:
						var timerCmd = function () {
							var _v6 = game.bZ.b6;
							if (!_v6.$) {
								return A5($author$project$Api$pauseTurn, model.g, model.l, game.bw, game.bZ.bS, game.bZ.b5);
							} else {
								return A5($author$project$Api$startTurn, model.g, model.l, game.bw, game.bZ.bS, game.bZ.b5);
							}
						}();
						var canSwitchTimer = A2($author$project$Game$Gameplay$isExplaining, game, localPlayer);
						return canSwitchTimer ? _Utils_Tuple2(model, timerCmd) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 27:
						if (A2($author$project$Game$Gameplay$isExplaining, game, localPlayer)) {
							var _v7 = game.bZ.b6;
							if (!_v7.$) {
								return _Utils_Tuple2(
									model,
									A5($author$project$Api$guessWord, model.g, model.l, game.bw, game.bZ.bS, game.bZ.b5));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 9:
						var value = msg.a;
						return A3($author$project$Main$gameChangedUpdate, value, model, gameModel);
					case 17:
						return (game.bZ.bJ === 1) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											gameModel,
											{aj: true, av: $elm$core$Maybe$Nothing}))
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 18:
						return gameModel.O ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											gameModel,
											{aj: false, av: $elm$core$Maybe$Nothing}))
								}),
							$elm$core$Platform$Cmd$none);
					case 19:
						return (gameModel.aj && ((!gameModel.O) && (game.bZ.bJ === 1))) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											gameModel,
											{O: true, av: $elm$core$Maybe$Nothing}))
								}),
							A4($author$project$Api$startBetweenRounds, model.g, model.l, game.bw, game.bZ.bS)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 20:
						var result = msg.a;
						if (!result.$) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cm: $author$project$State$Playing(
											_Utils_update(
												gameModel,
												{O: false}))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cm: $author$project$State$Playing(
											_Utils_update(
												gameModel,
												{
													O: false,
													av: $elm$core$Maybe$Just('Could not start the game. Try again.')
												}))
									}),
								$elm$core$Platform$Cmd$none);
						}
					case 21:
						var now = msg.a;
						var timedModel = _Utils_update(
							model,
							{aG: now});
						return _Utils_Tuple2(
							timedModel,
							A2($author$project$Main$dueTransitionCmd, timedModel, game));
					case 10:
						var onlinePlayerIds = msg.a;
						var nextGameModel = _Utils_update(
							gameModel,
							{
								aH: $elm$core$Set$fromList(onlinePlayerIds)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											nextGameModel,
											{
												x: A2($author$project$Main$presentGame, nextGameModel, gameModel.x)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						if (A2($author$project$Game$Gameplay$isOwner, game, localPlayer)) {
							switch (msg.$) {
								case 13:
									return _Utils_Tuple2(
										model,
										$author$project$Main$copyInviteLink(
											$elm$json$Json$Encode$string(game.bq)));
								case 11:
									var userId = msg.a;
									return gameModel.cD ? A2($author$project$Debugger$Update$update, msg, model) : _Utils_Tuple2(
										model,
										A4($author$project$Api$kickPlayer, model.g, model.l, userId, game.bw));
								case 12:
									return _Utils_Tuple2(
										model,
										A4($author$project$Api$startGame, model.g, model.l, game.bw, game.bZ.bS));
								default:
									return A2($author$project$Debugger$Update$update, msg, model);
							}
						} else {
							return A2($author$project$Debugger$Update$update, msg, model);
						}
				}
			} else {
				switch (msg.$) {
					case 9:
						var value = msg.a;
						return A3($author$project$Main$gameChangedUpdate, value, model, gameModel);
					case 10:
						var onlinePlayerIds = msg.a;
						var nextGameModel = _Utils_update(
							gameModel,
							{
								aH: $elm$core$Set$fromList(onlinePlayerIds)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Playing(
										_Utils_update(
											nextGameModel,
											{
												x: A2($author$project$Main$presentGame, nextGameModel, gameModel.x)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Main$saveUsernameToLocalStorage = _Platform_outgoingPort('saveUsernameToLocalStorage', $elm$core$Basics$identity);
var $author$project$Main$subscribeToGame = _Platform_outgoingPort('subscribeToGame', $elm$core$Basics$identity);
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.bO;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.bp,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.cY,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.bL,
					_Utils_ap(http, url.bv)),
				url.bI)));
};
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 44:
				var authToken = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l: authToken}),
					$elm$core$Platform$Cmd$none);
			case 25:
				var offsetMs = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aO: offsetMs}),
					$elm$core$Platform$Cmd$none);
			case 28:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aX: !model.aX}),
					$elm$core$Platform$Cmd$none);
			case 29:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aW: !model.aW}),
					$elm$core$Platform$Cmd$none);
			case 43:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var url = msg.a;
				var newRoute = $author$project$Route$parseUrl(url);
				switch (newRoute.$) {
					case 0:
						var gameCode = newRoute.a;
						var _v2 = model.cm;
						switch (_v2.$) {
							case 2:
								var gameModel = _v2.a;
								return _Utils_eq(gameModel.N, gameCode) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{D: newRoute, T: url}),
									$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$LoadingGameToJoin(
												{
													N: gameCode,
													d: $author$project$Request$loading(
														_Utils_Tuple2(model.b, gameCode))
												}),
											b: model.b + 1,
											D: newRoute,
											T: url
										}),
									A3($author$project$Api$findGame, model.g, model.b, gameCode));
							case 3:
								var gameModel = _v2.a;
								return _Utils_eq(gameModel.x.bq, gameCode) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{D: newRoute, T: url}),
									$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$LoadingGameToJoin(
												{
													N: gameCode,
													d: $author$project$Request$loading(
														_Utils_Tuple2(model.b, gameCode))
												}),
											b: model.b + 1,
											D: newRoute,
											T: url
										}),
									A3($author$project$Api$findGame, model.g, model.b, gameCode));
							case 4:
								var gameModel = _v2.a;
								return _Utils_eq(gameModel.x.bq, gameCode) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{D: newRoute, T: url}),
									$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$LoadingGameToJoin(
												{
													N: gameCode,
													d: $author$project$Request$loading(
														_Utils_Tuple2(model.b, gameCode))
												}),
											b: model.b + 1,
											D: newRoute,
											T: url
										}),
									A3($author$project$Api$findGame, model.g, model.b, gameCode));
							default:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$LoadingGameToJoin(
												{
													N: gameCode,
													d: $author$project$Request$loading(
														_Utils_Tuple2(model.b, gameCode))
												}),
											b: model.b + 1,
											D: newRoute,
											T: url
										}),
									A3($author$project$Api$findGame, model.g, model.b, gameCode));
						}
					case 1:
						var _v3 = model.cm;
						if (_v3.$ === 1) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{D: newRoute, T: url}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cm: $author$project$State$CreatingGame(
											{
												aB: model.ag + ('-' + $elm$core$String$fromInt(model.b)),
												A: '',
												d: $author$project$Request$idle
											}),
										b: model.b + 1,
										D: newRoute,
										T: url
									}),
								$elm$core$Platform$Cmd$none);
						}
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cm: $author$project$State$Initial(
										{E: 1, B: ''}),
									aD: _List_Nil,
									D: newRoute,
									T: url
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 1:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: $author$project$Main$invalidatePendingNavigation(model.cm)
							}),
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.ak,
							$elm$url$Url$toString(url)));
				} else {
					var href = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cm: $author$project$State$Initial(
								{E: 1, B: ''}),
							aD: _List_Nil
						}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.ak, '/'));
			default:
				var _v5 = model.cm;
				switch (_v5.$) {
					case 0:
						var gameModel = _v5.a;
						switch (msg.$) {
							case 8:
								return _Utils_Tuple2(
									model,
									A2(
										$elm$browser$Browser$Navigation$pushUrl,
										model.ak,
										$elm$core$String$concat(
											_List_fromArray(
												['/join/', gameModel.B]))));
							case 2:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$CreatingGame(
												{
													aB: model.ag + ('-' + $elm$core$String$fromInt(model.b)),
													A: '',
													d: $author$project$Request$idle
												}),
											b: model.b + 1
										}),
									A2($elm$browser$Browser$Navigation$pushUrl, model.ak, '/create'));
							case 15:
								var input = msg.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$Initial(
												{E: 1, B: input})
										}),
									$elm$core$Platform$Cmd$none);
							case 24:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$Initial(
												{E: gameModel.E + 1, B: gameModel.B})
										}),
									$elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 2:
						var gameModel = _v5.a;
						switch (msg.$) {
							case 4:
								var _v8 = A2(
									$author$project$Request$begin,
									_Utils_Tuple2(model.b, gameModel.N),
									gameModel.d);
								if (!_v8.$) {
									var request = _v8.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												cm: $author$project$State$LoadingGameToJoin(
													_Utils_update(
														gameModel,
														{d: request})),
												b: model.b + 1
											}),
										A3($author$project$Api$findGame, model.g, model.b, gameModel.N));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							case 39:
								var requestId = msg.a;
								var gameCode = msg.b;
								var result = msg.c;
								if (!A2(
									$author$project$Request$isActive,
									_Utils_Tuple2(requestId, gameCode),
									gameModel.d)) {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								} else {
									if (!result.$) {
										var game = result.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$JoiningGame(
														{x: game, A: '', d: $author$project$Request$idle})
												}),
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														$author$project$Main$subscribeToGame(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2('userId', $elm$json$Json$Encode$null),
																	_Utils_Tuple2(
																	'gameId',
																	$elm$json$Json$Encode$string(game.bw))
																]))),
														$author$project$Main$getUsernameFromLocalStorage(0)
													])));
									} else {
										var error = result.a;
										var message = function () {
											if ((error.$ === 3) && (error.a === 409)) {
												return 'This game uses an older running timer and cannot be recovered. Create a new game.';
											} else {
												return 'Could not find that game. Check the code and try again.';
											}
										}();
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$LoadingGameToJoin(
														_Utils_update(
															gameModel,
															{
																d: A3(
																	$author$project$Request$fail,
																	_Utils_Tuple2(requestId, gameCode),
																	message,
																	gameModel.d)
															}))
												}),
											$elm$core$Platform$Cmd$none);
									}
								}
							default:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 1:
						var gameModel = _v5.a;
						switch (msg.$) {
							case 3:
								var input = msg.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$CreatingGame(
												_Utils_update(
													gameModel,
													{
														A: $elm$core$String$toUpper(input)
													}))
										}),
									$elm$core$Platform$Cmd$none);
							case 6:
								if ($elm$core$String$isEmpty(
									$elm$core$String$trim(gameModel.A))) {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								} else {
									var _v12 = A2($author$project$Request$begin, model.b, gameModel.d);
									if (!_v12.$) {
										var request = _v12.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$CreatingGame(
														_Utils_update(
															gameModel,
															{d: request})),
													b: model.b + 1
												}),
											A5($author$project$Api$addGame, model.g, model.l, model.b, gameModel.aB, gameModel.A));
									} else {
										return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
									}
								}
							case 40:
								var requestId = msg.a;
								var result = msg.b;
								if (!A2($author$project$Request$isActive, requestId, gameModel.d)) {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								} else {
									if (!result.$) {
										var _v14 = result.a;
										var game = _v14.a;
										var player = _v14.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$Playing(
														A2(
															$author$project$Main$newPlaying,
															game,
															$author$project$State$LocalPlayer(player)))
												}),
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														$author$project$Main$subscribeToGame(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'userId',
																	$elm$json$Json$Encode$string(player.bw)),
																	_Utils_Tuple2(
																	'gameId',
																	$elm$json$Json$Encode$string(game.bw))
																]))),
														$author$project$Main$saveUsernameToLocalStorage(
														$elm$json$Json$Encode$string(player.bC)),
														A2(
														$elm$browser$Browser$Navigation$pushUrl,
														model.ak,
														$elm$core$String$concat(
															_List_fromArray(
																['/join/', game.bq])))
													])));
									} else {
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$CreatingGame(
														_Utils_update(
															gameModel,
															{
																d: A3($author$project$Request$fail, requestId, 'Could not create the game. Try again.', gameModel.d)
															}))
												}),
											$elm$core$Platform$Cmd$none);
									}
								}
							default:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 3:
						var gameModel = _v5.a;
						switch (msg.$) {
							case 3:
								var input = msg.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$JoiningGame(
												_Utils_update(
													gameModel,
													{
														A: $elm$core$String$toUpper(input)
													}))
										}),
									$elm$core$Platform$Cmd$none);
							case 45:
								var username = msg.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cm: $author$project$State$JoiningGame(
												_Utils_update(
													gameModel,
													{
														A: $elm$core$String$toUpper(username)
													}))
										}),
									$elm$core$Platform$Cmd$none);
							case 41:
								var requestId = msg.a;
								var gameId = msg.b;
								var result = msg.c;
								if (!A2(
									$author$project$Request$isActive,
									_Utils_Tuple2(requestId, gameId),
									gameModel.d)) {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								} else {
									if (!result.$) {
										var joinedGameInfo = result.a;
										var maybeLocalUser = function () {
											var _v19 = joinedGameInfo.c3;
											switch (_v19) {
												case 'player':
													return $elm$core$Maybe$Just(
														$author$project$State$LocalPlayer(joinedGameInfo.a$));
												case 'watcher':
													return $elm$core$Maybe$Just(
														$author$project$State$LocalWatcher(joinedGameInfo.a$));
												default:
													return $elm$core$Maybe$Nothing;
											}
										}();
										var game = gameModel.x;
										if (!maybeLocalUser.$) {
											var localUser = maybeLocalUser.a;
											var localUserName = function () {
												if (!localUser.$) {
													var player = localUser.a;
													return player.bC;
												} else {
													var watcher = localUser.a;
													return watcher.bC;
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														cm: $author$project$State$Playing(
															A2($author$project$Main$newPlaying, joinedGameInfo.x, localUser))
													}),
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															$author$project$Main$subscribeToGame(
															$elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'userId',
																		$elm$json$Json$Encode$string(joinedGameInfo.a$.bw)),
																		_Utils_Tuple2(
																		'gameId',
																		$elm$json$Json$Encode$string(game.bw))
																	]))),
															$author$project$Main$saveUsernameToLocalStorage(
															$elm$json$Json$Encode$string(localUserName))
														])));
										} else {
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														cm: $author$project$State$JoiningGame(
															_Utils_update(
																gameModel,
																{
																	d: A3(
																		$author$project$Request$fail,
																		_Utils_Tuple2(requestId, gameId),
																		joinedGameInfo.b_,
																		gameModel.d)
																}))
													}),
												$elm$core$Platform$Cmd$none);
										}
									} else {
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$JoiningGame(
														_Utils_update(
															gameModel,
															{
																d: A3(
																	$author$project$Request$fail,
																	_Utils_Tuple2(requestId, gameId),
																	'Could not join the game. Try again.',
																	gameModel.d)
															}))
												}),
											$elm$core$Platform$Cmd$none);
									}
								}
							case 7:
								if ($elm$core$String$isEmpty(
									$elm$core$String$trim(gameModel.A))) {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								} else {
									var _v20 = A2(
										$author$project$Request$begin,
										_Utils_Tuple2(model.b, gameModel.x.bq),
										gameModel.d);
									if (!_v20.$) {
										var request = _v20.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cm: $author$project$State$JoiningGame(
														_Utils_update(
															gameModel,
															{d: request})),
													b: model.b + 1
												}),
											A5($author$project$Api$joinGame, model.g, model.l, model.b, gameModel.x.bq, gameModel.A));
									} else {
										return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
									}
								}
							default:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					default:
						return A2($author$project$Main$playingGameUpdate, msg, model);
				}
		}
	});
var $author$project$State$AddGame = {$: 6};
var $author$project$State$JoinGame = {$: 7};
var $author$project$State$CancelStartConfirmation = {$: 18};
var $author$project$State$ConfirmStartPlaying = {$: 19};
var $author$project$State$OpenStartConfirmation = {$: 17};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$State$AddWord = {$: 16};
var $author$project$State$UpdateWordInput = function (a) {
	return {$: 14, a: a};
};
var $author$project$Request$error = function (state) {
	if (state.$ === 2) {
		var requestError = state.a;
		return $elm$core$Maybe$Just(requestError);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Request$isLoading = function (state) {
	if (state.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$State$DeleteWord = function (a) {
	return {$: 22, a: a};
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Game$Words$groupByPlayer = F2(
	function (word, wordsDict) {
		return A3(
			$elm$core$Dict$update,
			word.aJ,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$elm$core$List$cons(word)),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(
						_List_fromArray(
							[word])),
					$elm$core$Maybe$Just)),
			wordsDict);
	});
var $author$project$Game$Words$wordsByPlayer = A2($elm$core$List$foldr, $author$project$Game$Words$groupByPlayer, $elm$core$Dict$empty);
var $author$project$Views$AddingWords$localPlayersWords = F2(
	function (words, localUser) {
		var localWords = A2(
			$elm$core$Dict$get,
			localUser.bw,
			$author$project$Game$Words$wordsByPlayer(words.cL));
		var noWords = function () {
			if (localWords.$ === 1) {
				return 0;
			} else {
				var wordsList = localWords.a;
				return $elm$core$List$length(wordsList);
			}
		}();
		if (localWords.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var wordsList = localWords.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('local-words')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Words added: ' + $elm$core$String$fromInt(noWords))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('word-list')
							]),
						A2(
							$elm$core$List$map,
							function (_v1) {
								var id = _v1.bw;
								var word = _v1.bc;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('space-between')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(word)
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Events$onClick(
													$author$project$State$DeleteWord(id)),
													$elm$html$Html$Attributes$class('icon-button'),
													A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Remove ' + word)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('𝗫')
														]))
												]))
										]));
							},
							wordsList))
					]));
		}
	});
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Views$AddingWords$wordsInputView = F4(
	function (game, localUser, inputValue, request) {
		var isLoading = $author$project$Request$isLoading(request);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('words-input-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('word-entry-form'),
							$elm$html$Html$Events$onSubmit($author$project$State$AddWord)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('word')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add words, one at a time. Then play when the group has enough.')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$id('word'),
									A2($elm$html$Html$Attributes$attribute, 'name', 'word'),
									A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'on'),
									A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'characters'),
									A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'true'),
									$elm$html$Html$Attributes$placeholder('e.g. mango'),
									$elm$html$Html$Attributes$value(inputValue),
									$elm$html$Html$Events$onInput($author$project$State$UpdateWordInput),
									$elm$html$Html$Attributes$disabled(isLoading)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary'),
									$elm$html$Html$Attributes$type_('submit'),
									$elm$html$Html$Attributes$disabled(
									isLoading || $elm$core$String$isEmpty(
										$elm$core$String$trim(inputValue))),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-busy',
									isLoading ? 'true' : 'false')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									isLoading ? 'Adding…' : 'Add')
								]))
						])),
					function () {
					var _v0 = $author$project$Request$error(request);
					if (!_v0.$) {
						var requestError = _v0.a;
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error'),
									A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(requestError)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2($author$project$Views$AddingWords$localPlayersWords, game.bZ.aA, localUser)
				]));
	});
var $author$project$State$KickPlayer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Views$PlayerKick$canKickPlayer = F3(
	function (isOwner, localUser, player) {
		var localUserId = function () {
			if (!localUser.$) {
				var localPlayer = localUser.a;
				return localPlayer.bw;
			} else {
				var localWatcher = localUser.a;
				return localWatcher.bw;
			}
		}();
		return isOwner && (!_Utils_eq(localUserId, player.bw));
	});
var $author$project$Views$PlayerKick$kickPlayerButton = F3(
	function (isOwner, localUser, player) {
		return A3($author$project$Views$PlayerKick$canKickPlayer, isOwner, localUser, player) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon-button'),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(
					$author$project$State$KickPlayer(player.bw)),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Kick ' + (player.bC + ' from the game'))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('🚫')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$AddingWords$wordsStatisticsView = F4(
	function (words, players, isOwner, localUser) {
		var wordCountByPlayer = A2(
			$elm$core$Dict$map,
			F2(
				function (_v6, wordsList) {
					return $elm$core$List$length(wordsList);
				}),
			$author$project$Game$Words$wordsByPlayer(words.cL));
		var allPlayers = A2(
			$elm$core$Dict$map,
			F2(
				function (_v5, player) {
					return _Utils_Tuple2(player, 0);
				}),
			players);
		var statsData = A6(
			$elm$core$Dict$merge,
			F3(
				function (playerId, _v1, result) {
					var player = _v1.a;
					return A3(
						$elm$core$Dict$insert,
						playerId,
						_Utils_Tuple2(player, 0),
						result);
				}),
			F4(
				function (playerId, _v2, count, result) {
					var player = _v2.a;
					return A3(
						$elm$core$Dict$insert,
						playerId,
						_Utils_Tuple2(player, count),
						result);
				}),
			F3(
				function (_v3, _v4, result) {
					return result;
				}),
			allPlayers,
			wordCountByPlayer,
			$elm$core$Dict$empty);
		var stats = A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var player = _v0.a;
					var wordsCount = _v0.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('request'),
								$elm$html$Html$Attributes$class('space-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('player-stat-name')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(player.bC)
											])),
										A3($author$project$Views$PlayerKick$kickPlayerButton, isOwner, localUser, player)
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(wordsCount))
									]))
							]));
				},
				$elm$core$Dict$values(statsData)));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('join-requests-container'),
							$elm$html$Html$Attributes$class('words-stats-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Players')
								])),
							stats
						]))
				]));
	});
var $author$project$Views$AddingWords$addingWordsView = function (model) {
	var wordsInput = function () {
		var _v3 = model.cH;
		if (!_v3.$) {
			var localPlayer = _v3.a;
			return A4($author$project$Views$AddingWords$wordsInputView, model.x, localPlayer, model.aR, model.U);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var isOwner = function () {
		var _v2 = model.cH;
		if (!_v2.$) {
			var player = _v2.a;
			return A2($author$project$Game$Gameplay$isOwner, model.x, player);
		} else {
			var player = _v2.a;
			return A2($author$project$Game$Gameplay$isOwner, model.x, player);
		}
	}();
	var hasNoWords = $elm$core$List$isEmpty(model.x.bZ.aA.cL);
	var startButton = function () {
		var _v1 = model.cH;
		if (!_v1.$) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$OpenStartConfirmation),
						$elm$html$Html$Attributes$disabled(hasNoWords)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Let\'s play')
					]));
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var confirmationDialog = model.aj ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('start-confirmation-backdrop')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('start-confirmation-dialog'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'dialog'),
						A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true'),
						A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'start-confirmation-title')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('start-confirmation-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ready to start?')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Starting now will begin the game for everyone. Make sure everyone has finished adding their words.')
							])),
						function () {
						var _v0 = model.av;
						if (!_v0.$) {
							var requestError = _v0.a;
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error'),
										A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(requestError)
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('start-confirmation-actions')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$State$ConfirmStartPlaying),
										$elm$html$Html$Attributes$disabled(model.O)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										model.O ? 'Starting…' : 'Start for everyone')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary'),
										$elm$html$Html$Events$onClick($author$project$State$CancelStartConfirmation),
										$elm$html$Html$Attributes$disabled(model.O)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Keep adding words')
									]))
							]))
					]))
			])) : $elm$html$Html$text('');
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('adding-words-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Let’s add some words')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						wordsInput,
						A4($author$project$Views$AddingWords$wordsStatisticsView, model.x.bZ.aA, model.x.aI.aK, isOwner, model.cH),
						startButton
					])),
				confirmationDialog
			]));
};
var $author$project$Views$Playing$Round$getRoundText = function (round) {
	switch (round) {
		case 1:
			return 'describe the word';
		case 2:
			return 'charades';
		case 3:
			return 'one word guess';
		case 4:
			return 'The game has ended 🎉';
		default:
			return '';
	}
};
var $author$project$Views$BetweenRounds$betweenRoundsView = function (targetRound) {
	switch (targetRound) {
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('between-rounds-container'),
						$elm$html$Html$Attributes$class('section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-first')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Hope you are soooo ready...')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-second')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...Because it is time to EXPLAIN...')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-third')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...as many words as you can...')
							]))
					]));
		case 4:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('between-rounds-container'),
						$elm$html$Html$Attributes$class('section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-first')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Hope you had lots of fun...')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-second')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...Because the game has ended...')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-third large-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...aaaand...')
							]))
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('between-rounds-container'),
						$elm$html$Html$Attributes$class('section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-first')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Hope you remember the words...')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-second')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...Because now it’s time for...')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('show-third large-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Views$Playing$Round$getRoundText(targetRound))
							]))
					]));
	}
};
var $author$project$State$DebugGuessNextWords = {$: 37};
var $author$project$State$DebugLobby = {$: 31};
var $author$project$State$DebugRestart = {$: 30};
var $author$project$State$DebugRestartWords = {$: 33};
var $author$project$State$DebugSetNextPlayer = {$: 36};
var $author$project$State$DebugSetPlayerOnTurn = {$: 34};
var $author$project$State$DebugSetPlayerOwner = {$: 35};
var $author$project$State$DebugSetRound = function (a) {
	return {$: 38, a: a};
};
var $author$project$State$DebugStarted = {$: 32};
var $author$project$Debugger$Debugger$debugger = function (model) {
	var urlQueryParam = model.T.cY;
	var localUserName = function () {
		var _v1 = model.cm;
		if (_v1.$ === 4) {
			var gameModel = _v1.a;
			var _v2 = gameModel.cH;
			if (!_v2.$) {
				var p = _v2.a;
				return p.bC;
			} else {
				var w = _v2.a;
				return w.bC;
			}
		} else {
			return 'unknown';
		}
	}();
	var isUrlDebuggerEnabled = function () {
		if (!urlQueryParam.$) {
			var query = urlQueryParam.a;
			return A2($elm$core$String$contains, 'debug=true', query);
		} else {
			return false;
		}
	}();
	var isDebuggerEnabled = (model.cs === 'development') || isUrlDebuggerEnabled;
	return isDebuggerEnabled ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('debugger')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('DEBUGGER: ' + localUserName)
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugRestart)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Restart')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugLobby)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Lobby')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugStarted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Newly started')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugRestartWords)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Restart words')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugSetNextPlayer)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set next player')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugSetPlayerOnTurn)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set player on turn')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugSetPlayerOwner)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set player owner')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$DebugGuessNextWords)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Guess next words')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$State$DebugSetRound(1))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set round 1')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$State$DebugSetRound(2))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set round 2')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$State$ToggleDonateDialog = {$: 29};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Views$Donate$donateContent = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('donate-dialog'),
			$elm$html$Html$Events$onClick($author$project$State$ToggleDonateDialog)
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Are you enjoying the game and would like to support? 🥰')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('donate-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You can do so here ->')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://paypal.me/masadordevic'),
							$elm$html$Html$Attributes$class('donate-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('♥ Support')
						]))
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('close-button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('𝗫')
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('feedback')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('If you have any thoughts or feedback please email to: ')
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('mailto:masadordevic@gmail.com')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('masadordevic@gmail.com')
				]))
		]));
var $author$project$Views$Donate$donateView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('donate-dialog-container')
			]),
		_List_fromArray(
			[
				model.aW ? $author$project$Views$Donate$donateContent : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('donate-dialog-button'),
						$elm$html$Html$Events$onClick($author$project$State$ToggleDonateDialog)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('♥')
							]))
					]))
			]));
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Game$Teams$getScoreboard = function (teams) {
	var queued = function () {
		var _v0 = teams.aC;
		if (!_v0.$) {
			var team = _v0.a;
			return A2($elm$core$List$cons, team, teams.cL);
		} else {
			return teams.cL;
		}
	}();
	return A2(
		$elm$core$List$sortBy,
		function (team) {
			return -team.a3;
		},
		queued);
};
var $author$project$Game$Teams$members = F2(
	function (players, team) {
		return A2(
			$elm$core$List$filterMap,
			function (playerId) {
				return A2($elm$core$Dict$get, playerId, players);
			},
			team.a0);
	});
var $author$project$Game$Gameplay$teamMembers = F2(
	function (game, team) {
		return A2($author$project$Game$Teams$members, game.aI.aK, team);
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Views$Playing$Teams$teamPlayers = F2(
	function (game, team) {
		return $elm$html$Html$text(
			A2(
				$elm$core$String$join,
				' & ',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.bC;
					},
					A2($author$project$Game$Gameplay$teamMembers, game, team))));
	});
var $author$project$Views$Playing$Teams$teamView = F3(
	function (game, indexNumber, team) {
		var teamNumber = (!indexNumber) ? '🎉' : ('# ' + $elm$core$String$fromInt(indexNumber + 1));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('team-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(teamNumber)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Views$Playing$Teams$teamPlayers, game, team)
						])),
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('team-score')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(team.a3))
						]))
				]));
	});
var $author$project$Views$Playing$Teams$teamsView = function (game) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scoreboard-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Leader board')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('scoreboard-teams-container')
					]),
				A2(
					$elm$core$List$indexedMap,
					$author$project$Views$Playing$Teams$teamView(game),
					$author$project$Game$Teams$getScoreboard(game.bZ.a8))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('scoreboard-background')
					]),
				_List_Nil)
			]));
};
var $author$project$Views$FinishedGame$finishedGameView = function (game) {
	var winningTeam = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			function (team) {
				return $elm$html$Html$text(
					A2(
						$elm$core$String$join,
						' & ',
						A2(
							$elm$core$List$map,
							function ($) {
								return $.bC;
							},
							A2($author$project$Game$Gameplay$teamMembers, game, team))));
			},
			$elm$core$List$head(
				$author$project$Game$Teams$getScoreboard(game.bZ.a8))));
	var confetti = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('confetti-animation-container')
			]),
		A2(
			$elm$core$List$map,
			function (index) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'confetti-' + $elm$core$String$fromInt(index))
						]),
					_List_Nil);
			},
			A2($elm$core$List$range, 0, 200)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('finished-game-container')
			]),
		_List_fromArray(
			[
				confetti,
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('And the winners are')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('winners')
					]),
				_List_fromArray(
					[winningTeam])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('medal')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('\uD83E\uDD47')
					])),
				$author$project$Views$Playing$Teams$teamsView(game)
			]));
};
var $author$project$State$BackToStart = {$: 5};
var $author$project$State$RetryGameLookup = {$: 4};
var $author$project$Views$NameInput$gameLookupView = function (request) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('name-input-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('FINDING GAME')
					])),
				function () {
				var _v0 = $author$project$Request$error(request);
				if (!_v0.$) {
					var requestError = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error'),
										A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(requestError)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$State$RetryGameLookup)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Try again')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary'),
										$elm$html$Html$Events$onClick($author$project$State$BackToStart)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									]))
							]));
				} else {
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'role', 'status')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Loading game…')
							]));
				}
			}()
			]));
};
var $author$project$Views$Header$headerView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confetti-large'),
					$elm$html$Html$Attributes$class('mirrored')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('🎉')
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('THE MASHA GAME')
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confetti-large')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('🎉')
				]))
		]));
var $author$project$Views$Help$Hide = {$: 0};
var $author$project$Views$Help$Round = function (a) {
	return {$: 1, a: a};
};
var $author$project$State$ToggleHelpDialog = {$: 28};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Views$Help$helpContent = function (context) {
	_v0$4:
	while (true) {
		if (context.$ === 1) {
			switch (context.a) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Adding words')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Now all players add words that are going to be described later.')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Not sure what to write? Think about what you\'d like to see your friends charade')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Tips for competitive players:')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('There are only two rules: '),
										$elm$html$Html$text('words have to be '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('nouns')
											])),
										$elm$html$Html$text(' , and they '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('can\'t')
											])),
										$elm$html$Html$text(' be '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('proper nouns')
											]))
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Here are some examples: ')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('examples')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('correct')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('car')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('incorrect')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('blue car')
													])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text('(should be ONE generic term)')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('correct')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('government')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('incorrect')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Harry Potter')
													])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(' (should NOT be a proper noun)')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('correct')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('sunbed')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('incorrect')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('jump')
													])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(' (should be a noun)')
											]))
									])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('How many words should we add?')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('It\'s up to you to agree on! It depends on the number of players and how long you would like to play. We recommend having 35-50 words in total.')
									]))
							]));
				case 1:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Describing')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Once it\'s your turn to describe words you\'ll see the start button and words will show up.')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('There\'s only one rule: you can\'t say '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('the root of the word')
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('For example: if a word is \"sunbed\"'),
										$elm$html$Html$text(' avoid explaining it as \"a  '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('bed')
											])),
										$elm$html$Html$text(' you lay on while being on the '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('sun')
											])),
										$elm$html$Html$text(', or while '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('sun')
											])),
										$elm$html$Html$text('tanning\". All the '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('bold')
											])),
										$elm$html$Html$text(' words in the previous example are violations.')
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Some more examples would be:'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('examples')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('\"row row row your... \"')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('🤔 boat!')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('\"a car has 4... \"')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('🤔 wheels!... or wheel*')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('\"sour fruit... \"')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('lemon! ⛔️ lime?! ✅')
													]))
											]))
									]))
							]));
				case 2:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Charades')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We\'re playing standard charades with the same words that we had in the prevous round.')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('There\'s only one rule: you can\'t make sounds (for example humming or \"bzzz\" sounds)')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('🙊')
									]))
							]));
				case 3:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('One word')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('In this round we\'re explaining words with only '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('one word')
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We played two rounds with the same words already so we can explain words with only one word now! Here are some examples: ')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('examples')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('\"rowing... \"')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('🤔 boat!')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('\"steering... \"')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('🤔 wheel')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('\"sour... \"')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('lime')
											]))
									]))
							]));
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$html$Html$text('');
};
var $author$project$Views$Help$helpView = function (model) {
	var context = function () {
		var _v1 = model.cm;
		if (_v1.$ === 4) {
			var gameModel = _v1.a;
			return $author$project$Views$Help$Round(gameModel.x.bZ.c4);
		} else {
			return $author$project$Views$Help$Hide;
		}
	}();
	var shouldShow = function () {
		if (!context.$) {
			return false;
		} else {
			var round = context.a;
			return round >= 0;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('help-dialog-container')
			]),
		_List_fromArray(
			[
				model.aX ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('help-dialog')
					]),
				_List_fromArray(
					[
						$author$project$Views$Header$headerView,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('help-dialog-content')
							]),
						_List_fromArray(
							[
								$author$project$Views$Help$helpContent(context),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bottom')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('If something went wrong try refreshing the page and re-joining the game by entering the same game code and using the same username.')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('close-button'),
										$elm$html$Html$Events$onClick($author$project$State$ToggleHelpDialog)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('𝗫')
									]))
							]))
					])) : A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('help-dialog-button', true),
								_Utils_Tuple2('secondary', true),
								_Utils_Tuple2('hide', !shouldShow)
							])),
						$elm$html$Html$Attributes$type_('button'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Open help'),
						$elm$html$Html$Events$onClick($author$project$State$ToggleHelpDialog)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('?')
							]))
					]))
			]));
};
var $author$project$State$CopyInviteLink = {$: 13};
var $author$project$State$StartGame = {$: 12};
var $author$project$Views$Lobby$playersList = F3(
	function (users, isOwner, localUser) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('participants')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var user = _v0.b;
					var canBeKicked = A3($author$project$Views$PlayerKick$canKickPlayer, isOwner, localUser, user);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('space-between', canBeKicked),
										_Utils_Tuple2('request', true)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(user.bC)
									])),
								A3($author$project$Views$PlayerKick$kickPlayerButton, isOwner, localUser, user)
							]));
				},
				$elm$core$Dict$toList(users)));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Views$Lobby$lobbyView = function (model) {
	var isOwner = function () {
		var _v0 = model.cH;
		if (!_v0.$) {
			var player = _v0.a;
			return A2($author$project$Game$Gameplay$isOwner, model.x, player);
		} else {
			var player = _v0.a;
			return A2($author$project$Game$Gameplay$isOwner, model.x, player);
		}
	}();
	var titleCopy = isOwner ? 'Waiting for players to join' : 'Waiting for game to start';
	var cantStartGame = $elm$core$Dict$size(model.x.aI.aK) <= 1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lobby-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invite-to-game')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(titleCopy)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$State$CopyInviteLink),
								$elm$html$Html$Attributes$class('secondary')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Copy invite link 🔗')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('join-requests-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Players')
									])),
								A3($author$project$Views$Lobby$playersList, model.x.aI.aK, isOwner, model.cH)
							]))
					])),
				isOwner ? A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$State$StartGame),
						$elm$html$Html$Attributes$class('start-game'),
						$elm$html$Html$Attributes$disabled(cantStartGame)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('start game')
					])) : $elm$html$Html$text('')
			]));
};
var $author$project$State$UpdateNameInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$NameInput$nameInputView = F4(
	function (nameInput, loadingLabel, request, onClickMsg) {
		var isLoading = $author$project$Request$isLoading(request);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('name-input-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ADD A NICKNAME')
						])),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('nickname')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Nickname')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('nickname'),
							$elm$html$Html$Attributes$value(nameInput),
							$elm$html$Html$Events$onInput($author$project$State$UpdateNameInput),
							$elm$html$Html$Attributes$disabled(isLoading)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(onClickMsg),
							$elm$html$Html$Attributes$disabled(
							isLoading || $elm$core$String$isEmpty(
								$elm$core$String$trim(nameInput))),
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-busy',
							isLoading ? 'true' : 'false')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							isLoading ? loadingLabel : 'Enter')
						])),
					function () {
					var _v0 = $author$project$Request$error(request);
					if (!_v0.$) {
						var requestError = _v0.a;
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error'),
									A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(requestError)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$State$WordGuessed = {$: 27};
var $author$project$Constants$countdownMoment = 10;
var $author$project$Views$Playing$CurrentWord$currentWord = F2(
	function (word, turnTimer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('current-word-border', true),
									_Utils_Tuple2(
									'countdown10',
									_Utils_cmp(turnTimer, $author$project$Constants$countdownMoment) < 1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('current-word-container'),
									$elm$html$Html$Attributes$class('has-word')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('current-word'),
											$elm$html$Html$Events$onClick($author$project$State$WordGuessed)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(word.bc)
										]))
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('next-word'),
							$elm$html$Html$Events$onClick($author$project$State$WordGuessed)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Word guessed! Next word')
						]))
				]));
	});
var $author$project$Views$Playing$CurrentWord$readOnlyCurrentWord = F2(
	function (word, turnTimer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('current-word-border', true),
									_Utils_Tuple2(
									'countdown10',
									_Utils_cmp(turnTimer, $author$project$Constants$countdownMoment) < 1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('current-word-container'),
									$elm$html$Html$Attributes$class('has-word')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('current-word')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(word.bc)
										]))
								]))
						]))
				]));
	});
var $author$project$State$SwitchTimer = {$: 26};
var $author$project$Views$Playing$CurrentWord$start = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('current-word-container'),
			$elm$html$Html$Attributes$class('section')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('show-first')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('It’s your turn')
				])),
			A2(
			$elm$html$Html$h3,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('show-second')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('You’ll see the word here')
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('show-third'),
					$elm$html$Html$Events$onClick($author$project$State$SwitchTimer)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Start')
				]))
		]));
var $author$project$Views$Playing$CurrentWord$currentWordView = F3(
	function (game, localUser, turnTimer) {
		if (!localUser.$) {
			var localPlayer = localUser.a;
			if (A2($author$project$Game$Gameplay$isExplaining, game, localPlayer)) {
				var _v1 = game.bZ.aA.aC;
				if (!_v1.$) {
					var word = _v1.a;
					return A2($author$project$Views$Playing$CurrentWord$currentWord, word, turnTimer);
				} else {
					return $author$project$Views$Playing$CurrentWord$start;
				}
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			var _v2 = game.bZ.aA.aC;
			if (!_v2.$) {
				var word = _v2.a;
				return A2($author$project$Views$Playing$CurrentWord$readOnlyCurrentWord, word, turnTimer);
			} else {
				return $elm$html$Html$text('');
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Game$Gameplay$isLocalPlayersTurn = F2(
	function (game, player) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (team) {
					return A2($elm$core$List$member, player.bw, team.a0);
				},
				game.bZ.a8.aC));
	});
var $author$project$Views$Playing$Info$previousWord = function (game) {
	var prevWord = $elm$core$List$head(game.bZ.aA.cy);
	if (!prevWord.$) {
		var word = prevWord.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('info-container'),
					$elm$html$Html$Attributes$class('previous-word')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(word.bc)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('previous')
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Playing$Info$timeLeft = function (localTimer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('info-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('info-timer', true),
								_Utils_Tuple2(
								'countdown10',
								_Utils_cmp(localTimer, $author$project$Constants$countdownMoment) < 1)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(localTimer))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('seconds')
					]))
			]));
};
var $author$project$Game$Timer$label = function (turnTimer) {
	switch (turnTimer.$) {
		case 0:
			return 'Pause';
		case 1:
			return 'Continue';
		default:
			return '';
	}
};
var $author$project$Views$Playing$Info$timerButton = F2(
	function (game, isExplaining) {
		var timerString = $author$project$Game$Timer$label(game.bZ.b6);
		var shouldShowButton = timerString !== '';
		return isExplaining ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timer-button-container')
				]),
			_List_fromArray(
				[
					shouldShowButton ? A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timer-button'),
							$elm$html$Html$Events$onClick($author$project$State$SwitchTimer)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('material-icons')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('access_time')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(timerString)
								]))
						])) : $elm$html$Html$text('')
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Playing$Info$wordsLeft = F2(
	function (game, isExplaining) {
		var wordsLeftCount = function () {
			var _v0 = game.bZ.aA.aC;
			if (!_v0.$) {
				return 1 + $elm$core$List$length(game.bZ.aA.cL);
			} else {
				return $elm$core$List$length(game.bZ.aA.cL);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('info-container', true),
							_Utils_Tuple2('small', isExplaining)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(wordsLeftCount))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('words left')
						]))
				]));
	});
var $author$project$Views$Playing$Info$infoView = F3(
	function (game, localUser, localTimer) {
		var shouldSeePreviousWord = function () {
			if (!localUser.$) {
				var localPlayer = localUser.a;
				return !A2($author$project$Game$Gameplay$isLocalPlayersTurn, game, localPlayer);
			} else {
				return true;
			}
		}();
		var isExplaining = function () {
			if (!localUser.$) {
				var localPlayer = localUser.a;
				return A2($author$project$Game$Gameplay$isExplaining, game, localPlayer);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('turn-stats', true),
							_Utils_Tuple2('section', true),
							_Utils_Tuple2('on-turn', isExplaining)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Views$Playing$Info$wordsLeft, game, isExplaining),
					$author$project$Views$Playing$Info$timeLeft(localTimer),
					shouldSeePreviousWord ? $author$project$Views$Playing$Info$previousWord(game) : $elm$html$Html$text(''),
					A2($author$project$Views$Playing$Info$timerButton, game, isExplaining)
				]));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Game$Gameplay$explainer = function (game) {
	return A2(
		$elm$core$Maybe$andThen,
		function (playerId) {
			return A2($elm$core$Dict$get, playerId, game.aI.aK);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (team) {
				return $elm$core$List$head(team.a0);
			},
			game.bZ.a8.aC));
};
var $author$project$Views$Playing$Playing$playingNow = function (game) {
	var teamOnTurn = game.bZ.a8.aC;
	var score = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.a3;
			},
			teamOnTurn));
	var guessingPlayersNames = function () {
		if (!teamOnTurn.$) {
			var currentTeam = teamOnTurn.a;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.bC;
				},
				A2(
					$elm$core$List$drop,
					1,
					A2($author$project$Game$Gameplay$teamMembers, game, currentTeam)));
		} else {
			return _List_fromArray(
				['n/a']);
		}
	}();
	var guessingPlayers = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('guessing-players')
			]),
		A2(
			$elm$core$List$map,
			function (name) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]));
			},
			guessingPlayersNames));
	var explainingPlayer = A2(
		$elm$core$Maybe$withDefault,
		'n/a',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.bC;
			},
			$author$project$Game$Gameplay$explainer(game)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('info-container'),
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('team-on-turn')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('explaining-player')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(explainingPlayer)
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('☝️')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('score-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(score))
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('POINTS')
									]))
							])),
						guessingPlayers,
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('star-eyed-emoji')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('🤩')
							]))
					]))
			]));
};
var $author$project$Game$Timer$remainingSeconds = F3(
	function (serverTimeOffsetMs, now, turnTimer) {
		var remainingMs = function () {
			switch (turnTimer.$) {
				case 0:
					var deadlineMs = turnTimer.a;
					return deadlineMs - ($elm$time$Time$posixToMillis(now) + serverTimeOffsetMs);
				case 1:
					var pausedMs = turnTimer.a;
					return pausedMs;
				default:
					var durationMs = turnTimer.a;
					return durationMs;
			}
		}();
		return A2(
			$elm$core$Basics$max,
			0,
			$elm$core$Basics$ceiling(remainingMs / 1000));
	});
var $author$project$Views$Playing$Round$roundView = function (round) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('info-container'),
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Round ' + $elm$core$String$fromInt(round))
					])),
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Views$Playing$Round$getRoundText(round))
					]))
			]));
};
var $author$project$Views$Playing$Playing$playingView = F3(
	function (serverTimeOffsetMs, now, model) {
		var secondsLeft = A3($author$project$Game$Timer$remainingSeconds, serverTimeOffsetMs, now, model.x.bZ.b6);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('playing-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('playing-now')
						]),
					_List_fromArray(
						[
							$author$project$Views$Playing$Round$roundView(model.x.bZ.c4),
							A3($author$project$Views$Playing$CurrentWord$currentWordView, model.x, model.cH, secondsLeft),
							A3($author$project$Views$Playing$Info$infoView, model.x, model.cH, secondsLeft),
							$author$project$Views$Playing$Playing$playingNow(model.x)
						])),
					$author$project$Views$Playing$Teams$teamsView(model.x)
				]));
	});
var $author$project$Game$Gameplay$AddingWordsScreen = {$: 1};
var $author$project$Game$Gameplay$BetweenRoundsScreen = function (a) {
	return {$: 2, a: a};
};
var $author$project$Game$Gameplay$FinishedScreen = {$: 4};
var $author$project$Game$Gameplay$LobbyScreen = {$: 0};
var $author$project$Game$Gameplay$PlayingScreen = {$: 3};
var $author$project$Game$Gameplay$screen = function (game) {
	var _v0 = game.bZ.bJ;
	switch (_v0) {
		case 0:
			return $author$project$Game$Gameplay$LobbyScreen;
		case 1:
			return $author$project$Game$Gameplay$AddingWordsScreen;
		case 2:
			return $author$project$Game$Gameplay$BetweenRoundsScreen(
				A2($elm$core$Maybe$withDefault, game.bZ.c4 + 1, game.bZ.b3));
		case 3:
			return $author$project$Game$Gameplay$PlayingScreen;
		default:
			return $author$project$Game$Gameplay$FinishedScreen;
	}
};
var $author$project$State$SetCreatingGameMode = {$: 2};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Views$Start$startView = F2(
	function (model, erros) {
		var slideToShow = A2($elm$core$Basics$modBy, 6, model.E);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('start-game-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confetti'),
									$elm$html$Html$Attributes$class('mirrored')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('🎉')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pre-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Time to party, time for ')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confetti')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('🎉')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title-large')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('THE MASHA GAME')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('how-to-play')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('show', slideToShow === 1)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('assets/stickman-call.png')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('1. Gather in a call')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invite your friends to a call (e.g. Discord, Zoom, Meet)')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('show', slideToShow === 2)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('assets/stickman-writing2.png')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('2. Write some words')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Write words that your friends will guess during the game')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('show', slideToShow === 3)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('assets/stickman-teams2.png')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('3. Start Playing')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You will be divided into pairs')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('show', slideToShow === 4)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('assets/stickman-explaining.png')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('4. Describe the word')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Explain as many words as you can to your teammate (there is no skipping!)')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('show', slideToShow === 5)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('assets/stickman-learning2.png')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('5. Next rounds')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Remember all the words! They will be used in all rounds. Next up: Charades')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('show', !slideToShow)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('assets/stickman-one-word.png')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('6. Describe with ONE word')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('It might seem too hard but you remember the words, right?')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bars')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('animate', slideToShow === 1)
												]))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('animate', slideToShow === 2)
												]))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('animate', slideToShow === 3)
												]))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('animate', slideToShow === 4)
												]))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('animate', slideToShow === 5)
												]))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('animate', !slideToShow)
												]))
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('create-btn'),
									$elm$html$Html$Events$onClick($author$project$State$SetCreatingGameMode)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create new game')
								]))
						]))
				]));
	});
var $author$project$Views$View$view = function (model) {
	return {
		W: _List_fromArray(
			[
				function () {
				var showHeader = function () {
					var _v2 = model.cm;
					if (!_v2.$) {
						return false;
					} else {
						return true;
					}
				}();
				var currView = function () {
					var _v0 = model.cm;
					switch (_v0.$) {
						case 4:
							var gameModel = _v0.a;
							var _v1 = $author$project$Game$Gameplay$screen(gameModel.x);
							switch (_v1.$) {
								case 0:
									return $author$project$Views$Lobby$lobbyView(gameModel);
								case 1:
									return $author$project$Views$AddingWords$addingWordsView(gameModel);
								case 2:
									var targetRound = _v1.a;
									return $author$project$Views$BetweenRounds$betweenRoundsView(targetRound);
								case 3:
									return A3($author$project$Views$Playing$Playing$playingView, model.aO, model.aG, gameModel);
								default:
									return $author$project$Views$FinishedGame$finishedGameView(gameModel.x);
							}
						case 1:
							var gameModel = _v0.a;
							return A4($author$project$Views$NameInput$nameInputView, gameModel.A, 'Creating…', gameModel.d, $author$project$State$AddGame);
						case 2:
							var gameModel = _v0.a;
							return $author$project$Views$NameInput$gameLookupView(gameModel.d);
						case 3:
							var gameModel = _v0.a;
							return A4($author$project$Views$NameInput$nameInputView, gameModel.A, 'Joining…', gameModel.d, $author$project$State$JoinGame);
						default:
							var gameModel = _v0.a;
							return A2($author$project$Views$Start$startView, gameModel, model.aD);
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('page-container')
								]),
							_List_fromArray(
								[
									showHeader ? $author$project$Views$Header$headerView : $elm$html$Html$text(''),
									currView
								])),
							$author$project$Views$Donate$donateView(model),
							$author$project$Views$Help$helpView(model),
							$author$project$Debugger$Debugger$debugger(model)
						]));
			}()
			]),
		db: 'The Masha Game'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{cC: $author$project$Main$init, cT: $author$project$State$UrlChanged, cU: $author$project$State$LinkClicked, c8: $author$project$Main$subscriptions, dd: $author$project$Main$update, de: $author$project$Views$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (environment) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (createRequestKey) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (authToken) {
							return $elm$json$Json$Decode$succeed(
								{l: authToken, ag: createRequestKey, cs: environment});
						},
						A2($elm$json$Json$Decode$field, 'authToken', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'createRequestKey', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'environment', $elm$json$Json$Decode$string)))(0)}});}(this));